// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__fIEEx","footer":"ModalFilter_footer__l8x7f"};